<template>
    <v-btn 
        fab 
        :color="color" 
        @click="emit('clicked', $event)" 
        :small="small" 
        v-bind="$attrs" 
        v-on="$listeners"
    >
        
        <v-icon :small="small">{{ icon }}</v-icon>
        
    </v-btn>
</template>

<script setup>

import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    color: { type: String, default: 'primary' },
    icon: { type: String, required: true },
    small: { type: Boolean, default: false },
})

const emit = defineEmits(['clicked'])

</script>